<template>
    <div id="user-side-menu" class="card d-flex flex-column justify-content-start align-items-center w-100 h-100 mobileNav">
        <div class="d-none d-lg-flex flex-row justify-content-center align-items-center w-100">
            <div class="d-flex flex-column justify-content-center align-items-center h-100 w-100">
                <Skeletor v-if="userCapability < 0 || loadingUserImg" circle class="avatar" width="100%" height="100%" as="div"/>
                <div v-else class="d-flex flex-row avatar-container position-relative justify-content-center align-items-center h-100 w-100">
                    <div v-if="userImg" class="avatar w-100 h-100" :style="{ backgroundImage: 'url(' + userImg + ')' }"></div>
                    <div v-else class="avatar w-100 h-100" :style="{ backgroundImage: `url(${avatarPlaceholderPath})`}"></div>
                    <div class="overlay" :class="[loadingUserImg ? 'active' : '']">
                        <div v-if="!loadingUserImg" class="icon" @click="triggerUpload()"><Icon name="square-pen" :size="24" /></div>
                        <div v-if="loadingUserImg" class="icon"><Icon name="loader-2" :size="24" class="animate-spin" /></div>
                        <input id="user-profile-image" accept="image/png, image/jpg, image/jpeg, image/svg" type="file" @change="uploadUserImg($event.target.files, userEmail);" name="myfile" />
                    </div>
                </div>
            </div>
        </div>
        <div class="d-none d-lg-flex flex-row justify-content-start ms-2 align-items-center w-100 my-3">
            <Skeletor v-if="userCapability < 0 || !fullName" class="rounded-2" width="100%" height="24"/>
            <span v-else class="poppins-bold font-pure-black mb-0" id="full-username">{{fullName}}</span>
        </div>
        <div class="d-flex flex-row justify-content-center align-items-center w-100">
            <div class="d-flex mobile-navbar  align-items-center justify-content-lg-start align-items-lg-start w-100">
                <!-- mobile -->
                <Skeletor v-if="userCapability < 0" class="btn my-2 d-inline-block d-lg-none rounded-2" width="100%"/>
                <div v-else-if="!hasFullAccess" class="d-inline-block d-lg-none btn-large px-0 my-2 min-w-100 dropdown mx-2 disabled-by-capability locked-feature position-relative" @click="showUpgradeModal('Data Hub')" @mouseenter="showTooltip" @mouseleave="hideTooltip" @mousemove="updateTooltipPosition">
                  <div class="textNav dropdown-toggle min-w-100 menu-link btn btn-large d-flex flex-row justify-content-center disabled-by-capability" role="button">
                    <span class="ms-2 btnText">{{$t("content.datahub")}}</span>
                    <div class="mx-1"><Icon name="chevron-down" :size="16" /></div>
                  </div>
                </div>
                <router-link v-else class="d-inline-block d-lg-none btn-large px-0 my-2 min-w-100 dropdown mx-2" to="/platform/datahub/lookup">
                  <div class="textNav dropdown-toggle min-w-100 menu-link btn btn-large d-flex flex-row justify-content-center" role="button">
                    <span class="ms-2 btnText">{{$t("content.datahub")}}</span>
                    <div class="mx-1"><Icon name="chevron-down" :size="16" /></div>
                  </div>
                </router-link>
                <Skeletor v-if="userCapability < 0" class="btn my-2 ms-2 rounded-2" width="100%"/>
                <div v-else-if="!hasFullAccess" class="d-inline-block d-lg-none btn-large px-0 my-2 min-w-100 dropdown mx-2 disabled-by-capability locked-feature position-relative" @click="showUpgradeModal('Portfolio Hub')" @mouseenter="showTooltip" @mouseleave="hideTooltip" @mousemove="updateTooltipPosition">
                    <span class="btn btn-large d-flex flex-row justify-content-center menu-link min-w-100 disabled-by-capability">
                        <span>{{$t("content.portfolioHub")}}</span>
                    </span>
                </div>
                <router-link v-else class="d-inline-block d-lg-none btn-large px-0 my-2 min-w-100 dropdown mx-2" to="/platform/portfoliohub/clients">
                    <span class="btn btn-large d-flex flex-row justify-content-center menu-link min-w-100">
                        <span>{{$t("content.portfolioHub")}}</span>
                    </span>
                </router-link>

                <Skeletor v-if="userCapability < 0" class="btn my-2 d-inline-block d-lg-none rounded-2" width="100%"/>
                <div v-else-if="!hasFullAccess" class="d-inline-block d-lg-none btn-large px-0 my-2 min-w-100 dropdown mx-2 disabled-by-capability locked-feature position-relative" @click="showUpgradeModal('Customization')" @mouseenter="showTooltip" @mouseleave="hideTooltip" @mousemove="updateTooltipPosition">
                  <div class="textNav dropdown-toggle min-w-100 menu-link btn btn-large d-flex flex-row justify-content-center disabled-by-capability" role="button">
                    <span class="ms-2 btnText">{{$t("content.customization")}}</span>
                    <div class="mx-1"><Icon name="chevron-down" :size="16" /></div>
                  </div>
                </div>
                <router-link v-else class="d-inline-block d-lg-none btn-large px-0 my-2 min-w-100 dropdown mx-2" to="/platform/customization">
                  <div class="textNav dropdown-toggle min-w-100 menu-link btn btn-large d-flex flex-row justify-content-center" role="button">
                    <span class="ms-2 btnText">{{$t("content.customization")}}</span>
                    <div class="mx-1"><Icon name="chevron-down" :size="16" /></div>
                  </div>
                </router-link>

                <Skeletor v-if="userCapability < 0" class="btn my-2 d-inline-block d-lg-none rounded-2" width="100%"/>
                <router-link class="d-inline-block d-lg-none btn-large px-0 my-2 min-w-100 dropdown mx-2" to="/platform/phytech">
                  <div class="textNav dropdown-toggle min-w-100 menu-link btn btn-large d-flex flex-row justify-content-center" role="button">
                    <span class="ms-2 btnText">Extraction</span>
                  </div>
                </router-link>

                <router-link class="d-inline-block d-lg-none btn-large px-0 my-2 min-w-100 dropdown mx-2" to="/platform/uploads/library">
                  <div class="textNav dropdown-toggle min-w-100 menu-link btn btn-large d-flex flex-row justify-content-center" role="button">
                    <span class="ms-2 btnText">Library</span>
                  </div>
                </router-link>

                <Skeletor v-if="userCapability < 0" class="btn my-2 ms-2 rounded-2" width="100%"/>
                <div v-else class="d-inline-block d-lg-none btn-large px-0 my-2 min-w-100 dropdown mx-2" >
                    <custom-link class="btn btn-large d-flex flex-row justify-content-center menu-link min-w-100"   to="/platform/chat"
                        active-class="btn-primary poppins-bold" inactive-class="poppins-regular btn-outline-primary">
                        <span>{{$t("ImpactChat.AI")}}</span>
                    </custom-link>
                </div>

                <router-link class="d-inline-block d-lg-none btn-large px-0 my-2 min-w-100 dropdown mx-2" to="/platform/companies">
                  <div class="textNav dropdown-toggle min-w-100 menu-link btn btn-large d-flex flex-row justify-content-center" role="button">
                    <span class="ms-2 btnText">Companies</span>
                  </div>
                </router-link>
                <!-- Desktop -->
                <Skeletor v-if="userCapability < 0" class="btn my-2 d-none d-lg-inline-block rounded-2" width="100%"/>
                <div class="d-none d-lg-flex flex-column w-100 justify-content-start align-items-start" v-else>
                    <div class="d-none d-lg-flex flex-row justify-content-between align-items-center my-2 px-0 w-100 text-center">
                        <span v-if="!hasFullAccess" class="menu-link disabled-by-capability locked-feature position-relative" @click="showUpgradeModal('Data Hub')" @mouseenter="showTooltip" @mouseleave="hideTooltip" @mousemove="updateTooltipPosition">
                            <span>{{$t("content.datahub")}}</span>
                        </span>
                        <router-link v-else class="menu-link" to="/platform/datahub/lookup">
                            <span>{{$t("content.datahub")}}</span>
                        </router-link>
                        <div class="mx-1 collapsed" :class="{'disabled-by-capability': !hasFullAccess}" @click="toggleDatahubMenu" ref="datahubCollapse"><Icon name="chevron-down" :size="16" /></div>
                    </div>
                    <div class="collapse w-100" id="datahubMenu" ref="datahubMenu">
                        <div class="w-100 d-flex flex-column justify-content-start sub align-items-start">
                            <router-link v-if="hasFullAccess" class="d-none ms-1 d-lg-inline-block my-2 px-0 menu-link min-w-100" to="/platform/datahub/lookup">
                                <span>{{$t("content.lookup")}}</span>
                            </router-link>
                            <span v-else class="d-none ms-1 d-lg-inline-block my-2 px-0 menu-link min-w-100 disabled-by-capability">
                                <span>{{$t("content.lookup")}}</span>
                            </span>
                            <router-link v-if="hasFullAccess" class="d-none d-lg-inline-block ms-1 my-2 px-0 menu-link min-w-100" to="/platform/datahub/screening">
                                <span>{{$t("content.screening")}}</span>
                            </router-link>
                            <span v-else class="d-none d-lg-inline-block ms-1 my-2 px-0 menu-link min-w-100 disabled-by-capability">
                                <span>{{$t("content.screening")}}</span>
                            </span>
                            <router-link v-if="hasFullAccess" class="d-none d-lg-inline-block ms-1 my-2 px-0 menu-link min-w-100" to="/platform/datahub/matching">
                                <span>{{$t("content.matching")}}</span>
                            </router-link>
                            <span v-else-if="userCapability === 100" class="d-none d-lg-inline-block ms-1 my-2 px-0 menu-link min-w-100 disabled-by-capability">
                                <span>{{$t("content.matching")}}</span>
                            </span>
                        </div>
                    </div>
                </div>
                <Skeletor v-if="userCapability < 0" class="btn my-2 ms-2 rounded-2" width="100%"/>
                <!-- <template v-else-if="showPortfolioHubMenu && !sharingClient"> -->
                <template v-else-if="showPortfolioHubMenu">
                    <div class="d-none d-lg-flex flex-column w-100 justify-content-start align-items-start" >
                        <div class="d-none d-lg-flex flex-row justify-content-between align-items-center my-2 px-0 w-100 text-center">
                            <span v-if="!hasFullAccess" class="menu-link disabled-by-capability locked-feature position-relative" @click="showUpgradeModal('Portfolio Hub')" @mouseenter="showTooltip" @mouseleave="hideTooltip" @mousemove="updateTooltipPosition">
                                <span>{{$t("content.portfolioHub")}}</span>
                            </span>
                            <router-link v-else class="menu-link" to="/platform/portfoliohub/clients">
                                <span>{{$t("content.portfolioHub")}}</span>
                            </router-link>
                            <div class="mx-1 collapsed" :class="{'disabled-by-capability': !hasFullAccess}" @click="togglePortfolioHubMenu" ref="portfoliohubCollapse"><Icon name="chevron-down" :size="16" /></div>
                        </div>
                        <div class="collapse w-100" id="portfolioHubMenu" ref="portfolioHubMenu">
                            <div class="w-100 d-flex flex-column justify-content-start sub align-items-start">
                                <router-link v-if="hasFullAccess" class="d-none ms-1 d-lg-inline-block my-2 px-0 menu-link min-w-100" :to="{name: 'Information', params: { id: this.selectedClient.id ? this.selectedClient.id : ' ' }}">
                                    <span>{{$t("content.information")}}</span>
                                </router-link>
                                <span v-else class="d-none ms-1 d-lg-inline-block my-2 px-0 menu-link min-w-100 disabled-by-capability">
                                    <span>{{$t("content.information")}}</span>
                                </span>
                                <router-link v-if="hasFullAccess" class="d-none d-lg-inline-block ms-1 my-2 px-0 menu-link min-w-100" :to="{name: 'Performance Sustainable', params: { id: this.selectedClient.id ? this.selectedClient.id : ' ' }}">
                                    <span>{{$t("content.seeSustainable")}}</span>
                                </router-link>
                                <span v-else class="d-none d-lg-inline-block ms-1 my-2 px-0 menu-link min-w-100 disabled-by-capability">
                                    <span>{{$t("content.seeSustainable")}}</span>
                                </span>
                                <router-link v-if="hasFullAccess" class="d-none d-lg-inline-block ms-1 my-2 px-0 menu-link min-w-100" :to="{name: 'Financial Performance', params: { id: this.selectedClient.id ? this.selectedClient.id : ' ' }}">
                                    <span>{{$t("content.seeFinancial")}}</span>
                                </router-link>
                                <span v-else class="d-none d-lg-inline-block ms-1 my-2 px-0 menu-link min-w-100 disabled-by-capability">
                                    <span>{{$t("content.seeFinancial")}}</span>
                                </span>
                                <router-link v-if="hasFullAccess" class="d-none d-lg-inline-block ms-1 my-2 px-0 menu-link min-w-100" :to="{name: 'Portfolio', params: { id: this.selectedClient.id ? this.selectedClient.id : ' ' }}">
                                    <span>{{$t("content.seePortfolio")}}</span>
                                </router-link>
                                <span v-else class="d-none d-lg-inline-block ms-1 my-2 px-0 menu-link min-w-100 disabled-by-capability">
                                    <span>{{$t("content.seePortfolio")}}</span>
                                </span>
                                <div class="d-none d-lg-flex flex-column ms-1 my-2 px-0 min-w-100">
                                    <span class="menu-link share disabled-by-capability">
                                        {{$t('content.portfolioShare')}}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
                <span v-else-if="!hasFullAccess" class="d-none d-lg-inline-block my-2 menu-link min-w-100 disabled-by-capability locked-feature position-relative" @click="showUpgradeModal('Portfolio Hub')" @mouseenter="showTooltip" @mouseleave="hideTooltip" @mousemove="updateTooltipPosition">
                  <span>{{$t("content.portfolioHub")}}</span>
                </span>
                <router-link v-else class="d-none d-lg-inline-block my-2 menu-link min-w-100" to="/platform/portfoliohub/clients">
                  <span>{{$t("content.portfolioHub")}}</span>
                </router-link>
                <Skeletor v-if="userCapability < 0" class="btn my-2 d-none d-lg-inline-block rounded-2" width="100%"/>
                <span v-else-if="!hasFullAccess" class="d-none d-lg-inline-block my-2 menu-link min-w-100 disabled-by-capability locked-feature position-relative" @click="showUpgradeModal('Customization')" @mouseenter="showTooltip" @mouseleave="hideTooltip" @mousemove="updateTooltipPosition">
                  <span>{{$t("content.customization")}}</span>
                </span>
                <router-link v-else class="d-none d-lg-inline-block my-2 menu-link min-w-100" to="/platform/customization">
                  <span>{{$t("content.customization")}}</span>
                </router-link>
                <div class="d-none d-lg-flex flex-column w-100 justify-content-start align-items-start">
                    <div class="d-none d-lg-flex flex-row justify-content-between align-items-center my-2 px-0 w-100 text-center">
                        <span class="menu-link" style="cursor: pointer;" @click="togglePhytechMenu">
                            <span>PhyTech</span>
                        </span>
                        <div class="mx-1 collapsed" @click="togglePhytechMenu" ref="phytechCollapse"><Icon name="chevron-down" :size="16" /></div>
                    </div>
                    <div class="collapse w-100" id="phytechMenu" ref="phytechMenu">
                        <div class="w-100 d-flex flex-column justify-content-start sub align-items-start">
                            <router-link class="d-none ms-1 d-lg-inline-block my-2 px-0 menu-link min-w-100" to="/platform/phytech">
                                <span>Extraction</span>
                            </router-link>
                            <router-link class="d-none ms-1 d-lg-inline-block my-2 px-0 menu-link min-w-100" to="/platform/uploads/library">
                                <span>Library</span>
                            </router-link>
                        </div>
                    </div>
                </div>
                <Skeletor v-if="userCapability < 0" class="btn my-2 d-none d-lg-inline-block rounded-2" width="100%"/>
                <custom-link  class="d-none d-lg-inline-block my-2 menu-link min-w-100" :class="{'disabled-by-capability': userCapability == 8 || userCapability == 9}"   :to="userCapability == 8 || userCapability == 9 ? '' : {name: 'Chat'}"
                    :active-class="'active'" inactive-class="inactive">
                  <span>{{$t("content.AIchat")}}</span>
                </custom-link>
                <router-link class="d-none d-lg-inline-block my-2 menu-link min-w-100" to="/platform/companies">
                  <span>Report.AI</span>
                </router-link>
            </div>
        </div>
    </div>
    
    <!-- Global Tooltip -->
    <div id="global-menu-tooltip" class="locked-tooltip" style="display: none; position: fixed;">
        <Icon name="lock" :size="12" class="me-1" />
        Not available in Starter plan
    </div>

    <!-- Upgrade Modal -->
    <div v-if="showUpgradeModalVisible" class="upgrade-modal-overlay" @click="hideUpgradeModal">
        <div class="upgrade-modal" @click.stop>
            <div class="upgrade-modal-header">
                <h3>{{selectedFeature}} Not Available</h3>
                <button @click="hideUpgradeModal" class="close-btn">
                    <Icon name="x" :size="20" />
                </button>
            </div>
            <div class="upgrade-modal-content">
                <div class="upgrade-icon">
                    <Icon name="lock" :size="48" />
                </div>
                <p class="upgrade-message">
                    <strong>{{selectedFeature}}</strong> is not included in your current Starter plan.
                </p>
                <p class="upgrade-description">
                    Contact Physis to upgrade your plan and unlock advanced features including:
                </p>
                <ul class="features-list">
                    <li><Icon name="check" :size="16" class="text-success me-2" />Full Data Hub access</li>
                    <li><Icon name="check" :size="16" class="text-success me-2" />Portfolio Hub management</li>
                    <li><Icon name="check" :size="16" class="text-success me-2" />Advanced customization options</li>
                    <li><Icon name="check" :size="16" class="text-success me-2" />Extended company coverage</li>
                    <li><Icon name="check" :size="16" class="text-success me-2" />Enhanced analytics</li>
                </ul>
            </div>
            <div class="upgrade-modal-actions">
                <button @click="contactPhysis" class="btn-upgrade">
                    <Icon name="mail" :size="16" class="me-2" />
                    Contact Physis
                </button>
                <button @click="hideUpgradeModal" class="btn-cancel">
                    Maybe Later
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { signOut} from '../../http/auth';
import avatarPlaceholderPath from '@/assets/images/avatar-placeholder.png';
import { useToast } from "vue-toastification";
import { copyText } from 'vue3-clipboard';
import ToastNavigation from '@/components/platform/general/ToastNavigation.vue'

export default {
    setup() {
        const toast = useToast();
        return {toast};
    },
    data() {
        return {
            datahubArrow: false,
            datahubCusto: false,
            avatarPlaceholderPath: avatarPlaceholderPath,
            datahubNavItemsMobile: [
              {
                name: 'content.lookup',
                value: 'lookup-mobile',
                url: '/platform/datahub/lookup',
                minimumCapability: 1,
                children: null
              },
              {
                name: 'content.fund',
                value: 'screening-fund-mobile',
                url: '/platform/datahub/screening/fund',
                minimumCapability: 3,
                children: null
              },
              {
                name: 'content.company',
                value: 'screening-company-mobile',
                url: '/platform/datahub/screening/company',
                minimumCapability: 4,
                children: null
              },
              {
                name: 'content.country',
                value: 'screening-country-mobile',
                url: '/platform/datahub/screening/country',
                minimumCapability: 4,
                children: null
              },

            //   {
            //     name: 'matching',
            //     value: 'matching-mobile',
            //     url: '/platform/datahub/matching',
            //     minimumCapability: 4,
            //     children: null
            //   }
            ],
            customizationNavItemsMobile: [
                {
                    name: 'content.companyInfo',
                    value: 'companyInfo',
                    url: '/platform/customization/company_info',
                    children: null
                },
                {
                    name: 'content.api',
                    value: 'api',
                    url: '/platform/customization/api',
                    children: null
                },
                /*{
                name: 'notifications',
                value: 'notifications',
                url: '/platform/profile/notifications',
                children: null
                }*/
            ],
            profileNavItemsMobile: [
                {
                    name: 'content.accountInfo',
                    value: 'accountInfo',
                    url: '/platform/profile/account_info',
                    children: null
                },
                {
                    name: 'content.billing',
                    value: 'billing',
                    url: '/platform/profile/billing',
                    children: null
                },
                /*{
                name: 'notifications',
                value: 'notifications',
                url: '/platform/profile/notifications',
                children: null
                }*/
            ],
            clientShareStatus: 0,
            sharedClientTriggered: false,
            showUpgradeModalVisible: false,
            selectedFeature: ''
        }
    },
    props: {
      open: Boolean
    },
    computed: {
        fullName() {
            let fullName = this.$store.getters['profile/getUserFullName'];
            return fullName;
        },
        userImg() {
            let userImg = this.$store.getters['profile/getUserImg'];
            return userImg;
        },
        userEmail() {
            let userEmail = this.$store.getters['profile/getUserEmail'];
            return userEmail;
        },
        currentRoutePath() {
          return this.$route.fullPath;
        },
        loadingUserImg() {
            return this.$store.getters['profile/getLoadingUserImg'];
        },
        userCapability() {
          return this.$store.getters['profile/getUserCapability'];
        },
        hasFullAccess() {
            return parseInt(localStorage.getItem('access_level')) === 100;
        },
        selectedLang() {
            return this.$i18n.locale
        },
        sharingClient(){
          return this.$store.getters['getSharing'];
        },
        selectedClient() {
            let selectedClient = this.$store.getters['portfolioHub/getSelectedClient'];
            return selectedClient;
        },
        showPortfolioHubMenu() {
            // if(this.selectedClient && this.selectedClient.id !== '' && this.userCapability >=2 && this.userCapability != 6) 
            if(this.selectedClient && this.selectedClient.id !== '') 
                return true;
            else 
                return false;
        },
        paiCalculated() {
            return this.$store.getters['portfolioHub/getPAICalculated'];
        },
        calculatingPAI() {
            return this.$store.getters['pai/getCalculatingPAI'];
        },
        calculatingPAIError() {
            return this.$store.getters['pai/getCalculationError'];
        }
    },
    methods: {
        reverseArrow(a){
            if(a === "datahub"){
                if(this.datahubArrow === true){
                    this.datahubArrow = false;
                }
                else{
                    this.datahubArrow = true;
                }
            }
            else if(a === "custo"){
                if(this.datahubCusto === true){
                    this.datahubCusto = false;
                }
                else{
                    this.datahubCusto = true;
                }
            }
        },
        isChildActive(children) {
            let active = children.find(child => this.currentRoutePath.includes(child.url))
            if (active) {
                return true;
            }
            else {
                return false;
            }
        },
        isParentRouteActive(parentRoute) {
            if (this.currentRoutePath.includes(parentRoute)) 
                return true;
            else
                return false;
        },
        uploadUserImg(files, email) {
            if(files.length > 0) {
                let fileExt = files[0].name.substr(files[0].name.lastIndexOf('.') + 1); 
                if (fileExt == "svg" || fileExt == "png" || fileExt == "jpeg" || fileExt == "jpg") {
                    this.getBase64(files[0])
                        .then(data => {
                            this.$store.dispatch('profile/uploadUserImg', {userId: email, base64img: data})
                        }).catch(err => {
                            this.toast.error(this.$t('alert.error.anErrorHasOccurred'));
                            throw err;
                        });
                    }
                else {
                    this.toast.error(this.$t('alert.error.wrongImageFormat'));
                }

            }
        },
        getBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error)
            })
        },
        triggerUpload() {
            document.getElementById('user-profile-image').click();
        },
        checkCapabilities(check) {
          this.$store.dispatch('setCheckingCapabilityStatus', check);
        },
        logout() {
            signOut()
                .then(() => {
                    sessionStorage.removeItem('access_level');
                    this.$store.dispatch('profile/logout');
                    this.$router.push('/login');
                });
        },
        SetLocale(locale) {
            document.cookie = "lang=" + locale + "; domain=physisinvestment.com";
            this.$i18n.locale = locale;
        },
        shareClient(){
          this.clientShareStatus = -1;
          if (!this.paiCalculated) {
            this.toast.info(this.$t('alert.error.shareAvailableAfterPAI'), {timeout: false, id: 'calculating-pai-toast', closeButton: false, closeOnClick: false,});
            this.$store.dispatch('pai/calculatePAI', this.selectedClient.id);
            this.sharedClientTriggered = true;
          }
          else {
            try{
                var client = this.selectedClient;
                this.$store.dispatch('shareClient/shareClient', client.id)
                let shareClientUrl = this.$router.resolve({
                    name: 'Share Client',
                    params: { id: client.id }
                }).href;
                    copyText( window.location.origin + shareClientUrl, undefined, (error) => {
                        if (error) {
                            this.clientShareStatus = 2;
                        } else {
                            this.clientShareStatus = 1;
                        }
                    })
                
            }catch (err){
                this.clientShareStatus = 2;
            }
            setTimeout(() => {
                this.clientShareStatus = 0;
            }, 5000);
            console.log('here')
          }
        },
        checkCollapsables(collapse) { 
            if (!this.sharingClient) {
                if (collapse === 'portfoliohubCollapse') {
                    // TODO: removed capabilities on portfolioHub
                    // this.checkCapabilities(this.userCapability < 2 || this.userCapability == 6);
                    if(this.$refs[collapse] === null || !this.$refs[collapse]?.classList.contains('collapsed')) {
                        this.$refs.datahubCollapse.classList.add('collapsed');
                        this.$refs.datahubMenu.classList.remove('show');
                    }
                }
                else if (collapse === null) {
                    if(this.$refs.portfoliohubCollapse && !this.$refs.portfoliohubCollapse?.classList.contains('collapsed')) {
                        this.$refs.portfoliohubCollapse.classList.add('collapsed');
                        this.$refs.portfolioHubMenu.classList.remove('show');
                    }
                    if(this.$refs.datahubCollapse && !this.$refs.datahubCollapse?.classList.contains('collapsed')) {
                        this.$refs.datahubCollapse.classList.add('collapsed');
                        this.$refs.datahubMenu.classList.remove('show');
                    }
                }
                else {
                    if(this.$refs[collapse] !== null && !this.$refs[collapse]?.classList.contains('collapsed')) {
                        if (this.$refs.portfoliohubCollapse) {
                            this.$refs.portfoliohubCollapse.classList.add('collapsed');
                            this.$refs.portfolioHubMenu.classList.remove('show');
                        }
                    }
                }
            }
        },
        triggerMethods(collapse, accessLv) {
            console.log('triggerMethods', this.userCapability, accessLv);
            if(!this.$isDemoPortfolio()) {
                this.checkCapabilities(this.userCapability < accessLv);
                this.checkCollapsables(collapse)
                if(this.$refs[collapse].classList.contains('collapsed')) {
                    this.$refs[collapse].click();
                }
            }
        },
        showUpgradeModal(feature) {
            this.selectedFeature = feature;
            this.showUpgradeModalVisible = true;
        },
        hideUpgradeModal() {
            this.showUpgradeModalVisible = false;
        },
        contactPhysis() {
            this.hideUpgradeModal();
            window.location.href = 'mailto:Physis@physisinvestment.com';
        },
        showTooltip(event) {
            const tooltip = document.getElementById('global-menu-tooltip');
            if (tooltip) {
                tooltip.style.display = 'block';
                this.updateTooltipPosition(event);
            }
        },
        hideTooltip() {
            const tooltip = document.getElementById('global-menu-tooltip');
            if (tooltip) {
                tooltip.style.display = 'none';
            }
        },
        updateTooltipPosition(event) {
            const tooltip = document.getElementById('global-menu-tooltip');
            if (tooltip && tooltip.style.display === 'block') {
                // Position tooltip to bottom-right of cursor
                tooltip.style.top = `${event.clientY + 10}px`;
                tooltip.style.left = `${event.clientX + 10}px`;
            }
        },
        toggleDatahubMenu() {
            const datahubCollapse = this.$refs.datahubCollapse;
            const datahubMenu = this.$refs.datahubMenu;

            if (datahubCollapse && datahubMenu) {
                if (datahubCollapse.classList.contains('collapsed')) {
                    datahubCollapse.classList.remove('collapsed');
                    datahubMenu.classList.add('show');
                } else {
                    datahubCollapse.classList.add('collapsed');
                    datahubMenu.classList.remove('show');
                }
            }
        },
        togglePortfolioHubMenu() {
            const portfolioHubCollapse = this.$refs.portfoliohubCollapse;
            const portfolioHubMenu = this.$refs.portfolioHubMenu;

            if (portfolioHubCollapse && portfolioHubMenu) {
                if (portfolioHubCollapse.classList.contains('collapsed')) {
                    portfolioHubCollapse.classList.remove('collapsed');
                    portfolioHubMenu.classList.add('show');
                } else {
                    portfolioHubCollapse.classList.add('collapsed');
                    portfolioHubMenu.classList.remove('show');
                }
            }
        },
        toggleUploadsMenu() {
            const uploadsCollapse = this.$refs.uploadsCollapse;
            const uploadsMenu = this.$refs.uploadsMenu;

            if (uploadsCollapse && uploadsMenu) {
                if (uploadsCollapse.classList.contains('collapsed')) {
                    uploadsCollapse.classList.remove('collapsed');
                    uploadsMenu.classList.add('show');
                } else {
                    uploadsCollapse.classList.add('collapsed');
                    uploadsMenu.classList.remove('show');
                }
            }
        },
        togglePhytechMenu() {
            const phytechCollapse = this.$refs.phytechCollapse;
            const phytechMenu = this.$refs.phytechMenu;

            if (phytechCollapse && phytechMenu) {
                if (phytechCollapse.classList.contains('collapsed')) {
                    phytechCollapse.classList.remove('collapsed');
                    phytechMenu.classList.add('show');
                } else {
                    phytechCollapse.classList.add('collapsed');
                    phytechMenu.classList.remove('show');
                }
            }
        }
    },
    components: {
    },
    watch: {
        selectedClient(newVal) {
            if(newVal && newVal.id !== '' && !this.sharingClient) {
                this.clientShareStatus = 0;
                setTimeout(() => {
                    this.$refs.datahubCollapse.classList.add('collapsed');
                    this.$refs.datahubMenu.classList.remove('show');
                    this.$refs.portfoliohubCollapse.click();
                });
            }
        },
        paiCalculated(newVal) {
            if (newVal) {
                if (this.sharedClientTriggered) {
                    const content = {
                        component: ToastNavigation,
                        props: {
                            url: null,
                            action: 'shareClient',
                            actionMsg: 'content.here',
                            msg: 'alert.error.calculationCompleteShare'
                        },
                        listeners: {
                            shareClient: () => {
                                this.shareClient();
                                this.toast.dismiss('pai-calculated-share');
                            }
                        }
                    }
                    this.toast.dismiss('calculating-pai-toast');
                    setTimeout(() => {
                        this.toast.info(content, {timeout: false, id: 'pai-calculated-share', closeButton: "button", closeOnClick: false,}); 
                    }, 500);

                    this.sharedClientTriggered = false;
                }
                else {
                    this.clientShareStatus = 0;
                }
                if(this.clientShareStatus == -1)
                    this.toast.dismiss('calculating-pai-toast');
            }
        },
        calculatingPAIError(newVal) {
            if (newVal) {
                this.toast.dismiss('calculating-pai-toast');
                this.clientShareStatus = 0;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
// Variables auto-injected via vue.config.js

.textNav{
    color: $bootstrap-primary !important;

}
#user-side-menu {
    .mobileNav{
        overflow-x: auto;

    }
    @media screen and (min-width: 992px) {
        .mobile-navbar{
            flex-direction: column;
        }
        
    }
    @media screen and (max-width: 991px){
        .mobile-navbar{
            flex-direction: column;
        } 
    }
.btn-large {
    font-family: Poppins-Bold;

}
    .avatar-container, .avatar, .overlay {
        max-width: 112px;
        min-width: 112px;
        max-height: 112px;
        min-height: 112px;
    }
    &.card{
        box-shadow: unset;
        background: $white;
    }
    .logo-container {
        img {
            max-width: 112px;
        }
    }
    .overlay {
        .icon {
            &.fa-circle-notch {
                top: 36% !important;
                left: 36% !important;
            }
        }
    }
    .avatar-container {
        #user-profile-image {
            display: none;
        }
    }
    #datahubMenu, #portfolioHubMenu {
        :deep(.menu-link) {
            font-size: 0.875rem;
            text-decoration: none;
            &.active {
                span {
                    background: -webkit-linear-gradient($blue 0%, $dark-blue 100%);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    font-family: 'Poppins-Bold';
                    position: relative;
                    text-decoration: none;
                    &::after {
                        content: "";
                        position: absolute;
                        bottom: 3px;
                        left: 0;
                        height: 1px;
                        width: 100%;
                        background: $blue;
                        background: -webkit-linear-gradient($blue 0%, $dark-blue 100%);
                    }
                }
            }
            &.category {
                opacity: 0.65;
            }
        }
    }
    .logout {
        a {
            color: $text-dark;
        }
    }
    .collapsed {
        svg {
            transform: rotate(0deg) !important;
            transition: transform 400ms ease;
        }
    }
    :not(.collapsed) {
        svg {
            transform: rotate(180deg);
            transition: transform 400ms ease;
        }
    }
    .collapse {
        display: block !important;
        max-height: 0 !important;
        overflow: hidden !important;
        transition: max-height 400ms ease-in-out !important;

        &.show {
            max-height: 500px !important;
        }
    }
    .sub {
        border-top: 1px solid rgba($pure-black, 0.125);
        border-bottom: 1px solid rgba($pure-black, 0.125);
    }
    .extras {
        border-top: 1px solid rgba($pure-black, 0.125);
        position: absolute;
        bottom: 0;
        .menu-link {
            font-size: 0.875rem;
        }
    }
    .link-message{
        &.teal{
            color: $teal!important;
        }
        &.red{
            color: $red!important;
        }
    }
    #full-username {
        font-size: 1.125rem;
    }
    :deep(.menu-link) {
        font-size: 1rem;
        text-decoration: none;
        &.active {
            span {
                background: $blue;
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                font-family: 'Poppins-Bold';
                position: relative;
                text-decoration: none;

            }
        }
        &.inactive {
            span {
                color: $text-dark;
            }
        }
        &.btn-large{
            max-width: clamp(130px, 248px, 100%);
        }
        .icon {
            color: $text-dark;
        }
        &.share {
            &.disabled {
                pointer-events: none;
                cursor: pointer;
                opacity: .65;
            }
            color: $text-dark;
        }
        @media screen and (min-width: 992px) {
            .icon {
                transform: rotate(180deg);
            }
        }
        @media screen and (max-width: 991px) {
            &.btn-primary {
                .icon {
                    color: $white;
                }
            }
             &.btn-outline-primary {
                .icon {
                    color: $text-dark;
                }
            }
        }
    }
    @media screen and (min-width: 900px) {
        #supportCTA-wrapper{
            display: flex !important;
            margin: 0 auto;
            #supportCTA{
                .mobile {
                    display: none;
                }
                span {
                    text-transform: capitalize;
                    text-decoration: underline;
                    color: $blue;
                }
                svg{
                    height: 1rem;
                    width: 1rem;
                    padding: 2px;
                    margin-bottom: -2px;
                    border: 1px solid;
                    
                }
            }
        }
    }
    @media screen and (max-width: 899px) {
        #supportCTA-wrapper {
            display: none;
        }
    }
    :deep{
      [aria-expanded='true']{
        +{
          #top-navigation-dropdown-datahub-mobile,
          #top-navigation-dropdown-profile-mobile,
          #top-navigation-dropdown-customization-mobile{
            position: relative!important;
            inset: unset!important;
            transform: unset!important;
            border: none;
            max-height: unset;
            padding: 16px 0 8px!important
          }
        }
      }
      .dropdown-divider{
        width: 100%;
        border-top-color: $border-light !important;
      }
    }
}

.locked-feature {
    position: relative;
    cursor: pointer !important;
}

.locked-tooltip {
    background: $gray-dark;
    color: $white;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 0.75rem;
    white-space: nowrap;
    z-index: 1000;
    pointer-events: none;
}

.upgrade-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba($pure-black, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10000;
}

.upgrade-modal {
    background: $white;
    border-radius: 8px;
    max-width: 500px;
    width: 90%;
    max-height: 90vh;
    overflow-y: auto;
    box-shadow: 0 4px 20px rgba($pure-black, 0.15);
    
    .upgrade-modal-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 1.5rem;
        border-bottom: 1px solid $border-light;

        h3 {
            margin: 0;
            color: $gray-dark;
            font-size: 1.25rem;
        }

        .close-btn {
            background: none;
            border: none;
            font-size: 1.25rem;
            color: $gray;
            cursor: pointer;
            padding: 0.25rem;

            &:hover {
                color: $gray-dark;
            }
        }
    }

    .upgrade-modal-content {
        padding: 1.5rem;
        text-align: center;

        .upgrade-icon {
            margin-bottom: 1rem;

            i {
                font-size: 3rem;
                color: $gray;
            }
        }

        .upgrade-message {
            font-size: 1.1rem;
            margin-bottom: 1rem;
            color: $gray-dark;
        }

        .upgrade-description {
            color: $gray;
            margin-bottom: 1.5rem;
        }

        .features-list {
            list-style: none;
            padding: 0;
            text-align: left;
            max-width: 300px;
            margin: 0 auto 1.5rem;

            li {
                padding: 0.5rem 0;
                color: $gray-dark;
                
                i {
                    width: 20px;
                }
            }
        }
    }
    
    .upgrade-modal-actions {
        padding: 1rem 1.5rem 1.5rem;
        display: flex;
        gap: 1rem;
        justify-content: center;
        
        .btn-upgrade {
            background: $blue;
            color: white;
            border: none;
            padding: 0.75rem 1.5rem;
            border-radius: 4px;
            font-weight: 500;
            cursor: pointer;
            transition: background-color 0.2s;
            
            &:hover {
                background: #0090ee;
            }
        }
        
        .btn-cancel {
            background: transparent;
            color: #6c757d;
            border: 1px solid #6c757d;
            padding: 0.75rem 1.5rem;
            border-radius: 4px;
            cursor: pointer;
            transition: all 0.2s;
            
            &:hover {
                background: #6c757d;
                color: white;
            }
        }
    }
}

</style>
